import { hmac, textEncoder } from '@gem/utils';

import { AMZ_SCOPE_REQUEST_NAME, AMZ_SIGNING_KEY_PREFIX } from '../constants';
import { IStorageSessionCredentials } from '../types';

export async function getRemoteStorageSigningKeyBuffer(
  credentials: IStorageSessionCredentials,
  dateStamp: string
): Promise<ArrayBuffer> {
  const kDate = await hmac(
    textEncoder.encode(`${AMZ_SIGNING_KEY_PREFIX}${credentials.secretAccessKey}`),
    dateStamp
  );
  const kRegion = await hmac(kDate, credentials.region);
  const kService = await hmac(kRegion, credentials.serviceName);
  return hmac(kService, AMZ_SCOPE_REQUEST_NAME);
}
